import type { Fragment } from '../translations';

export const admin: Fragment = {
  fr: {
    'adm.tab.users': 'Utilisateurs & rôles',
    'adm.tab.people': 'Personnes & fonctions',
    'adm.tab.repo': 'Répertoire',
    'adm.tab.audit': 'Journal d\'audit',
    'adm.people.title': 'Personnes',
    'adm.people.add': 'Ajouter une personne',
    'adm.people.name': 'Nom',
    'adm.people.email': 'Courriel',
    'adm.people.function': 'Fonction',
    'adm.people.linked': 'Compte lié',
    'adm.functions.title': 'Fonctions',
    'adm.functions.add': 'Ajouter une fonction',
    'adm.repo.provider': 'Fournisseur',
    'adm.repo.branch': 'Branche',
    'adm.repo.synced': 'Dernière synchronisation',
    'adm.repo.resync': 'Resynchroniser',
    'adm.repo.health': 'Santé du catalogue',
    'adm.repo.health.total': '{n} fichiers',
    'adm.repo.health.empty': '{n} vides',
    'adm.repo.health.duplicates': '{n} doublons',
    'adm.repo.health.technical': '{n} fichiers techniques',
    'adm.repo.health.errors': '{n} illisibles',
    'adm.repo.showTechnical': 'Afficher les fichiers techniques',
    'adm.repo.notConfigured': 'Dépôt non configuré : créez l\'application GitHub ci-dessus (ou, en développement, renseignez GITHUB_TOKEN ou REPO_LOCAL_PATH).',
    'adm.repo.localRo': 'Mode développement : les modifications ne sont pas commitées (REPO_LOCAL_WRITE=0).',
    'adm.roles.role': 'Rôle CdE',
    'adm.appearance': 'Apparence',
    'adm.accent': 'Couleur d\'accent',
    'adm.accentDesc': 'La couleur principale de l\'application.',
  },
  en: {
    'adm.tab.users': 'Users & roles',
    'adm.tab.people': 'People & functions',
    'adm.tab.repo': 'Repository',
    'adm.tab.audit': 'Audit log',
    'adm.people.title': 'People',
    'adm.people.add': 'Add a person',
    'adm.people.name': 'Name',
    'adm.people.email': 'Email',
    'adm.people.function': 'Function',
    'adm.people.linked': 'Linked account',
    'adm.functions.title': 'Functions',
    'adm.functions.add': 'Add a function',
    'adm.repo.provider': 'Provider',
    'adm.repo.branch': 'Branch',
    'adm.repo.synced': 'Last sync',
    'adm.repo.resync': 'Resync',
    'adm.repo.health': 'Catalogue health',
    'adm.repo.health.total': '{n} files',
    'adm.repo.health.empty': '{n} empty',
    'adm.repo.health.duplicates': '{n} duplicates',
    'adm.repo.health.technical': '{n} technical files',
    'adm.repo.health.errors': '{n} unreadable',
    'adm.repo.showTechnical': 'Show technical files',
    'adm.repo.notConfigured': 'Repository not configured: create the GitHub App above (or, in development, set GITHUB_TOKEN or REPO_LOCAL_PATH).',
    'adm.repo.localRo': 'Development mode: changes are not committed (REPO_LOCAL_WRITE=0).',
    'adm.roles.role': 'CdE role',
    'adm.appearance': 'Appearance',
    'adm.accent': 'Accent colour',
    'adm.accentDesc': 'The application\'s primary colour.',
  },
};
